module.exports = __webpack_public_path__ + "images/emoji/point_down.34c01ee7fec45b6440b2.png";